import TextField from '@mui/material/TextField';
import Tx from './Tx';
import { useState } from 'react';
import IconBtn from './IconBtn';
import { TextValidator } from 'react-material-ui-form-validator';


function Text(props) {
    const id = String(Math.random());
    const [showPassword, setShowPassword] = useState(false);

    const TextCmp = props.validators ? TextValidator : TextField;

    const validarorsAttr = props.validators ? { validators: props.validators, errorMessages: props.errorMessages } : {};

    return (
        <div style={{ marginBottom: 10, position: props.type == 'password' ? 'relative' : '' }}>
            <TextCmp
                fullWidth={true}
                value={props.value}
                type={
                    props.type == 'password'
                        ?
                        ((props.type == 'password' && showPassword) ? 'text' : 'password')
                        :
                        (props.type || 'text')
                }
                onChange={e => { props.onChange && props.onChange(e.target.value) }}
                id={id}
                error={props.error}
                helperText={props.helperText}
                variant={props.variant || "outlined"}
                disabled={props.disabled}
                {...validarorsAttr}
                label={<Tx>{props.label}</Tx>} />
            {
                props.type == 'password' && <IconBtn
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ position: 'absolute', top: 9, right: 10, color: '#ccc', background: 'none' }}>
                    {showPassword ? 'eye' : 'eyeOff'}
                </IconBtn>
            }

        </div>
    )

}
export default Text;